import React, { forwardRef, useCallback, useMemo, useState } from 'react';
import { UiIcon, UiLoading, UiMenu } from 'ui-components';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import domToImage from 'dom-to-image';

const getHeaders = (title) => {
  let includedHeaders = {};

  const isBrandbaan = window.location.pathname.includes('/brandbaan');

  switch (title) {
    case 'روند انتشار کامنت‌ها': {
      if (isBrandbaan) {
        includedHeaders = {
          time: 'زمان',
          q: 'نوع',
          count: 'تعداد',
        };
      } else {
        includedHeaders = {
          time: 'زمان',
          count: 'تعداد',
        };
      }
      break;
    }
    case 'روند انتشار مطلب':
    case 'روند رشد اعضا':
    case 'روند رشد فالوورها':
      includedHeaders = {
        time: 'زمان',
        count: 'تعداد',
      };
      break;
    case 'ابر کلمات': {
      includedHeaders = {
        text: 'کلمه',
        value: 'تعداد',
      };
      break;
    }
    case 'پراکندگی جغرافیایی مطالب مرتبط با موضوع شما':
    case 'پراکندگی جغرافیایی محتوای منتشرشده این منبع': {
      includedHeaders = {
        text: 'اسم استان',
        value: 'تعداد',
      };
      break;
    }
    case 'منابع پرنفوذ': {
      includedHeaders = {
        name: 'نام منبع',
        username: 'یوزرنیم منبع',
        vote: 'امتیاز',
      };
      break;
    }
    case 'توزیع جنسیت': {
      includedHeaders = {
        item: 'جنسیت',
        count: 'تعداد',
        percent: 'درصد',
      };
      break;
    }
    case 'توزیع رده سنی': {
      includedHeaders = {
        item: 'بازه سنی',
        count: 'تعداد',
        percent: 'درصد',
      };
      break;
    }
    case 'تحلیل احساسات پست‌ها':
    case 'تحلیل احساسات مطالب':
    case 'جهت گیری مطالب':
    case 'جهت گیری کامنت‌ها': {
      includedHeaders = {
        item: 'احساسات',
        count: 'تعداد',
        percent: 'درصد',
      };
      break;
    }
    case 'دسته بندی محتوا': {
      includedHeaders = {
        type: 'نام دسته بندی',
        name: 'نام زیر دسته',
        value: 'نسبت',
      };
      break;
    }
    case 'ابر هشتگ‌ها': {
      includedHeaders = {
        text: 'هشتگ',
        value: 'تعداد',
      };
      break;
    }
    case 'رشد 5 هشتگ برتر': {
      includedHeaders = {
        time: 'زمان',
        q: 'هشتگ',
        count: 'تعداد',
      };
      break;
    }
    case 'مطالب دست اول و بازنشر شده': {
      includedHeaders = {
        item: 'نوع مطلب',
        count: 'تعداد',
        percent: 'درصد',
      };
      break;
    }
    case 'تغییرات سهم صدا': {
      includedHeaders = {
        time: 'زمان',
        q: 'نوع سهم صدا',
        count: 'تعداد',
      };
      break;
    }
    case 'مقایسه آماری استوری‌ها':
    case 'توزیع سهم صدا': {
      includedHeaders = {
        item: 'نام برند',
        count: 'تعداد',
        percent: 'درصد',
      };
      break;
    }
    case 'روند انتشار مطالب':
      includedHeaders = {
        time: 'زمان',
        q: 'نوع',
        count: 'تعداد',
      };
      break;
    case 'تغییرات شاخص خالص جهت‌گیری': {
      if (isBrandbaan) {
        includedHeaders = {
          time: 'زمان',
          q: 'نوع',
          count: 'شاخص خالص جهت‌گیری (nss)',
        };
      } else {
        includedHeaders = {
          name: 'تاریخ',
          nss: 'شاخص خالص جهت‌گیری (nss)',
          positive: 'سهم مطالب مثبت (%)',
          neutral: 'سهم مطالب خنثی (%)',
          negative: 'سهم مطالب منفی (%)',
        };
      }
      break;
    }
    case 'مقایسه روند استوری شما با رقبا': {
      includedHeaders = {
        name: 'زمان',
        myBrand: 'استوری‌های شما',
        competitorBrand: 'استوری‌های رقیب',
      };
      break;
    }
    case 'نمودار تحلیل رضایت کاربران براساس امتیاز': {
      includedHeaders = {
        positive: 'تعداد دیدگاه‌های راضی (امتیاز ۴ و ۵)',
        neutral: 'تعداد دیدگاه‌های خنثی (امتیاز ۳)',
        negative: 'تعداد دیدگاه‌های ناراضی (امتیاز ۱ و ۲)',
        nps: 'شاخص رضایت (nps)',
      };
      break;
    }
    case 'روند تغییرات تعداد محصولات به تفکیک محصولات فعال و دارای موجودی': {
      includedHeaders = {
        time: 'زمان',
        q: 'نوع محصول',
        count: 'تعداد',
      };
      break;
    }
    case 'سهم شما از دیدگاه‌ها': {
      includedHeaders = {
        item: 'برند',
        count: 'تعداد دیدگاه ها',
        percent: 'درصد',
      };
      break;
    }
    case 'ابر ایموجی':
    case 'لیست ایموجی': {
      includedHeaders = {
        text: 'ایموجی',
        value: 'تعداد',
      };
      break;
    }
  }
  return includedHeaders;
};

const ExportMenu = forwardRef(
  ({ title = 'image', data, hideCsv = false }, ref) => {
    const { t } = useTranslation();
    const [loading, setLoading] = useState(false);
    const [closeMenu, setCloseMenu] = useState(0);
    const platformElement = ref?.current?.querySelector(
      '.export-image-platform'
    );

    const handleDownloadImage = useCallback(async () => {
      if (!ref?.current) return;

      try {
        setLoading(true);

        if (platformElement) {
          platformElement.style.display = 'inline-block';
        }
        const pngLink = await domToImage.toPng(ref.current, {
          cacheBust: true,
          filter: (node) => {
            // Exclude all <img> tags and elements with excluded class from the conversion.

            // Check if current node has the excluded class
            const hasExcludedClass = node.classList?.contains(
              'excluded-from-image-download'
            );

            return node.nodeName.toLowerCase() !== 'image' && !hasExcludedClass;
          },
        });
        if (platformElement) {
          platformElement.style.display = 'none';
        }
        const downloadLink = document.createElement('a');
        downloadLink.href = pngLink;
        downloadLink.download = `${title}.png`;

        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
      } finally {
        setLoading(false);
        setCloseMenu((prev) => prev + 1);
      }
    }, [platformElement, ref, title]);

    const handleDownloadCsv = useCallback(() => {
      try {
        if (!data || !data.length) {
          // eslint-disable-next-line no-console
          console.error('No data to download');
          setCloseMenu((prev) => prev + 1);
          return;
        }

        const includedHeaders = getHeaders(title);
        const keys = Object.keys(includedHeaders);

        const rows = data.map((row) =>
          keys
            .map((key) => {
              const value = row[key] ?? '';
              const escaped = String(value).replace(/"/g, '""');
              return `"${escaped}"`;
            })
            .join(',')
        );

        const headers = keys.map((key) => includedHeaders[key]);

        const csvString = [headers.join(','), ...rows].join('\n');

        const BOM = '\uFEFF';

        const blob = new Blob([BOM + csvString], {
          type: 'text/csv;charset=utf-8;',
        });

        const url = URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = url;
        link.setAttribute(
          'download',
          `${title}${platformElement?.textContent || ''}.csv`
        );
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        setCloseMenu((prev) => prev + 1);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
        setCloseMenu((prev) => prev + 1);
      }
    }, [data, platformElement, title]);

    const actionsList = useMemo(
      () => [
        {
          title: t('common:downloadImage'),
          iconSrc: 'ri-image-2-line',
          render: (action) => (
            <UiLoading spinning={loading}>
              <span className='info flex' onClick={handleDownloadImage}>
                <UiIcon icon={action.iconSrc} color='#FFFFFF60' />
                <span>{action?.title}</span>
              </span>
            </UiLoading>
          ),
        },
        !hideCsv && {
          title: t('common:downloadCsv'),
          iconSrc: 'ri-file-excel-line',
          render: (action) => (
            <span className='info flex' onClick={handleDownloadCsv}>
              <UiIcon icon={action.iconSrc} color='#FFFFFF60' />
              <span>{action?.title}</span>
            </span>
          ),
        },
      ],
      [handleDownloadCsv, handleDownloadImage, hideCsv, loading, t]
    );

    return (
      <div className='download-image'>
        <UiMenu
          actionsList={actionsList}
          forceClose={closeMenu}
          button={
            <UiIcon
              icon='ri-download-2-fill'
              className='excluded-from-image-download'
            />
          }
        />
      </div>
    );
  }
);

ExportMenu.propTypes = {
  title: PropTypes.string,
  data: PropTypes.array,
  hideCsv: PropTypes.bool,
};

export default ExportMenu;
